import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Loaded inside the OAuth popup after the backend callback redirects here.
 * Uses BroadcastChannel to notify the parent window — window.opener is null
 * after traversing Google's COOP: same-origin page, so postMessage doesn't work.
 * BroadcastChannel is origin-scoped and unaffected by COOP.
 */
export default function OAuthRelayPage() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const creds = searchParams.get('creds')
    const email = searchParams.get('email') ?? ''
    const error = searchParams.get('error')

    const channel = new BroadcastChannel('google_oauth')

    if (error) {
      channel.postMessage({ type: 'google_oauth_error', error })
    } else if (creds) {
      channel.postMessage({ type: 'google_oauth_success', encrypted_credentials: creds, email })
    }

    channel.close()
    window.close()
  }, [])

  return (
    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', paddingTop: '4rem' }}>
      <p>Connecting… this window will close automatically.</p>
    </div>
  )
}
